import { AeSummaryCaseTableComponent } from 'app/crm/ae-summary-case-table/ae-summary-case-table.component'
import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  AfterViewInit
} from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { AuthorizeService } from '../../service/authorize.service'
import { StoreService } from '../../service/store.service'
import { ExportExcelService } from 'app/service/export-excel.service';
import { AeSummaryVisitSummaryByTeamComponent } from 'app/crm/ae-summary-visit-summary-by-team/ae-summary-visit-summary-by-team.component';
// tslint:disable-next-line:max-line-length
import { AeSummaryVisitSummaryByIndividualComponent } from '../ae-summary-visit-summary-by-individual/ae-summary-visit-summary-by-individual.component';
import { AeSummaryCaseStockComponent } from 'app/crm/ae-summary-case-stock/ae-summary-case-stock.component';
@Component({
  selector: 'app-ae-summary',
  templateUrl: './ae-summary.component.html',
  styleUrls: ['./ae-summary.component.scss']
})
export class AeSummaryComponent implements OnInit, AfterViewInit {
  @Output() changeTab = new EventEmitter()
  @ViewChild(AeSummaryCaseTableComponent)
  aeSummaryCaseTableComponent: AeSummaryCaseTableComponent;

  @ViewChild(AeSummaryVisitSummaryByTeamComponent)
  aeSummaryVisitSummaryByTeamComponent: AeSummaryVisitSummaryByTeamComponent;


  @ViewChild(AeSummaryVisitSummaryByIndividualComponent)
  aeSummaryVisitSummaryByIndividualComponent: AeSummaryVisitSummaryByIndividualComponent;

  @ViewChild(AeSummaryCaseStockComponent)
  aeSummaryCaseStockComponent: AeSummaryCaseStockComponent;

  getPrint
  yearByIndividual
  yearByTeam
  pdf = false
  print = false
  printPage = false
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService,
    private store: StoreService,
    private excelService: ExportExcelService,
  ) { }

  reInitialTable() {
    this.aeSummaryCaseTableComponent.onChangeData()
  }

  ngOnInit() {
    const { pdf, print } = this.activatedRoute.snapshot.data
    const { yearByTeam } = this.activatedRoute.snapshot.params
    const { yearByIndividual } = this.activatedRoute.snapshot.params
    this.getPrint = print

    if (yearByTeam !== undefined) {
      this.yearByTeam = yearByTeam
    }
    if (yearByIndividual !== undefined) {
      this.yearByIndividual = yearByIndividual
    }

    !!pdf ? (this.pdf = pdf) : (this.pdf = false)
    !!print ? (this.print = print) : (this.print = false)

    if (this.print || this.pdf) {
      this.printPage = true
    } else {
      this.printPage = false
    }
  }

  handleYearByIndividualChange(event) {
    this.yearByIndividual = event
  }

  handleYearByTeamChange(event) {
    this.yearByTeam = event
  }

  exportFunctionsAeSummary() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmailAeSummary(
        this.yearByTeam,
        this.yearByIndividual,
        this.cpmService
      )
    )
    arrayOfFunctions.set(
      'print',
      this.exportPrintAeSummary(this.yearByTeam, this.yearByIndividual)
    )
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfAeSummary(this.yearByTeam, this.yearByIndividual)
    )
    arrayOfFunctions.set(
      'excel',
      this.exportExcelAeSummary(this.aeSummaryCaseTableComponent,
        this.aeSummaryVisitSummaryByTeamComponent,
        this.aeSummaryVisitSummaryByIndividualComponent,
        this.aeSummaryCaseStockComponent,
        this.excelService)
    );
    return arrayOfFunctions
  }

  exportPrintAeSummary = function (yearByteam, yearByIndividual) {
    return function executiveSummaryPrint() {
      window.open(
        `/#/crmaesummary/${yearByteam}/${yearByIndividual}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }
  exportPdfAeSummary = function (yearByteam, yearByIndividual) {
    const service = this.cpmService
    return function executiveSummaryPdf() {
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/crmaesummary?yearByTeam=${yearByteam}&yearByIndividual=${yearByIndividual}`,
        '_blank'
      )
    }
  }

  exportEmailAeSummary = function (yearByteam, yearByIndividual, service) {
    return function mailCrm() {
      service.saveCrmAeSummary(yearByteam, yearByIndividual).then(filename => {
        const subject = 'Crm AE Summary'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }


  exportExcelAeSummary(aeSummaryCaseTableComponent,
    aeSummaryVisitSummaryByTeamComponent,
    aeSummaryVisitSummaryByIndividualComponent,
    aeSummaryCaseStockComponent,
    excelService) {
    return function excelAeSummary() {
      const data = {
        sheet_name: ['All records by AE', 'Visit Summary', 'By individual', 'Case คงค้าง'],
        ws_data: [
          !!aeSummaryCaseTableComponent.ws_data_toExcel ? aeSummaryCaseTableComponent.ws_data_toExcel : null
          , !!aeSummaryVisitSummaryByTeamComponent.ws_data_toExcel ? aeSummaryVisitSummaryByTeamComponent.ws_data_toExcel : null
          , !!aeSummaryVisitSummaryByIndividualComponent.ws_data_toExcel ? aeSummaryVisitSummaryByIndividualComponent.ws_data_toExcel : null
          , !!aeSummaryCaseStockComponent.ws_data_toExcel ? aeSummaryCaseStockComponent.ws_data_toExcel : null]

      }
      excelService.exportExcelAeSummary(data)
    }
  }

  sendcaseId(event) {
    this.cpmService.getSecurityProfileNew(event.symbol)
    this.changeTab.emit(2)
  }

  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('CRM_AE_SUM')
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary/ae-summary.component.ts